// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8863aadf","239":"fc1948d8","732":"f1f795fc"}[chunkId] + ".chunk.js";
};